export default __webpack_public_path__ + "static/media/family.80ea04dc.svg";